import { FC, memo } from 'react'

import { Link, useNavigate } from '@tanstack/react-router'
import { TableDataQa } from 'commons/types/enums'
import { Button } from 'ui/components/Buttons'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useDeletePeriodConfirmation } from '~bank-documents/hooks/useDeletePeriodConfirmation'
import { DocumentDetailsPeriodItem } from '~bank-documents/types/documentDetails'

import { DocumentPeriodsProps } from './DocumentPeriods.types'
import { columns } from './columns'

export const DocumentPeriods: FC<DocumentPeriodsProps> = memo(({ documentPeriods, documentId, isLastDelivery }) => {
  const { DeletePeriodConfirmation, showDeletePeriodConfirmation } = useDeletePeriodConfirmation()
  const navigate = useNavigate()

  return (
    <PageSection
      face={PageSectionFace.SECONDARY}
      title="Document Periods"
      actions={
        <Link
          to="/documents/$documentId/new-period"
          params={{ documentId: documentId.toString() }}
          search={isLastDelivery ? { isLastDelivery } : undefined}
          resetScroll={false}
        >
          <Button face="tertiary">Add New</Button>
        </Link>
      }
    >
      <DeletePeriodConfirmation />
      <Layer rounded shadowed>
        <Table<DocumentDetailsPeriodItem>
          dataQa={TableDataQa.BP_DOCUMENT_DOCUMENTS_PERIODS}
          columns={columns({ documentId, onDeletePeriod: showDeletePeriodConfirmation, navigate })}
          dataSource={documentPeriods?.map((item) => ({ item }))}
        />
      </Layer>
    </PageSection>
  )
})
